import { Controller } from "@hotwired/stimulus"
import { Sortable } from 'sortablejs';

export default class extends Controller {
  static targets = [
    "draggableContainer"
  ]

  connect() {
    this.sortable = new Sortable(this.draggableContainerTarget, {
      animation: 150,
      draggable: '.draggableItem',
      handle: '.draggableHandle',
      onEnd: () => {
        this.sortableSort()
      },
    });
  }

  sortableSort() {
    requestAnimationFrame(() => {
      const items = Array.from(this.draggableContainerTarget.children).filter((el) =>
        el.matches('.draggableItem')
      );
      console.log(items)
      items.forEach((item, index) => {
        const hiddenInput = item.querySelector('input[type="hidden"].order_key');
        if (hiddenInput) {
          hiddenInput.value = index;
          hiddenInput.setAttribute('value', index);
        }
      });
    })
  }
}
